<template>
  <div class="stock-customers-page">
    <section class="hero-banner">
      <div class="banner-content">
        <div class="text-content">
          <h1 class="brand-name">红土证券</h1>
          <h2 class="main-title">保险客户</h2>
          <p class="subtitle">本页面内容由集团关联公司红土财富提供</p>
        </div>
      </div>
    </section>

    <section class="longbridge-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">专业保险经纪覆盖全方位人群</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz1.png" alt="低费率">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">高净值家庭与个人：需要定制化方案，如家族信托、跨境资产配置，注重私密性与长期服务</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz2.png" alt="专业工具">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">成长型年轻家庭：首次置业、新婚或育儿阶段的家庭，需求集中在重疾险、医疗险、定期寿险、教育金，注重
                性价比，偏好线上沟通与灵活缴费方式</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz3.png" class="w-13 h-13" alt="广泛市场">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">小微企业主与创业者：关注企业财产险、雇主责任险、团体健康险，需平衡个人与企业资产隔离（如股东互保、寿
                险融资），对条款灵活性和理赔效率要求高</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz4.png" alt="便捷出入金">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">专业人士与高知群体：医生、律师、企业高管等高收入专业人士，偏好数据化分析、条款深度解读，关注全球医疗
                资源、高端养老服务</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="个性化服务">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">特定行业从业人员：高风险职业（如建筑、货运）、自由职业者，需定制意外险、职业责任险，常被标准产品排
                除或加费</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="安全保障">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">互联网原住民与新中产：习惯线上比价、自主研究条款，关注消费型保险、短期健康险、互联网定制产品，注重服务
                响应速度与线上工具使用体验</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="exclusive-privileges py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="privilege-cards">
            <img src="@/assets/11f19c2a8408ff9cd9e8975bf4d617ac.png" alt="股票客户特权">
          </div>
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">您的核心风险与需求洞察</h3>
            <ul class="space-y-4 mb-6">
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">健康透支风险：高强度工作、不规律作息，需防范重疾与医疗费用对储蓄的冲击。</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">家庭责任初显：可能开始赡养父母或组建家庭，需一份高杠杆的意外与寿险保障。</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">现金流管理：收入增长期，需平衡保障与储蓄，偏好灵活、高性价比的产品组合。</span>
              </li>

            </ul>
            <div class="highlight-box p-4 pl-0 mb-6">
              <p class="text-[#ef7c5b] font-semibold text-lg">深入沟通，精准识别您的家庭结构、财务状况与核心风险，奠定科学规划基础。</p>
            </div>
            <a :href="resolveLink(externalLinks.privilegeLearnMore)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer text-white px-8 py-2 rounded-3xl font-semibold transition-colors inline-block text-center">了解详情</a>
          </div>
        </div>
      </div>
    </section>

    <section class="investor-tools py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">以流程见证专业，以透明构建信任需求分析</h3>
            <ul class="space-y-6">
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">协助投保</p>
                  <p class="text-gray-700 leading-relaxed">全程指导填写投保资料，协助健康告知，确保流程合规，从源头规避未来纠纷。</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">保单托管</p>
                  <p class="text-gray-700 leading-relaxed">为您电子化归档所有保单，清晰呈现保障全景，关键日期智能提醒，确保保障持续有效。</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">协助理赔与维权</p>
                  <p class="text-gray-700 leading-relaxed">出险时第一时间响应，全程指导并代办理赔，遇争议时以专业立场为您据理力争。</p>
                </div>
              </li>
            </ul>
            <a :href="resolveLink(externalLinks.investorTools)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer text-white px-8 py-2 mt-4 rounded-3xl font-semibold transition-colors inline-block text-center">了解详情</a>
          </div>
          <div class="phone-showcase flex justify-center">
            <img src="@/assets/514464cfbcd130f45e3951737a27355d.png" alt="工具展示">
          </div>
        </div>
      </div>
    </section>

    <section class="tech-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">专业的保险经纪服务体系</h2>
          <p class="text-base text-gray-800 mt-2">贴心为你搭配专属保障，智能守护每一次选择</p>
        </div>
        <div class="flex gap-6 mb-6 items-center text-gray-600">
          <button v-for="tab in techTabs" :key="tab.key" class="nav-tab" :class="{ active: currentTechTab===tab.key }" @click="currentTechTab=tab.key">{{ tab.label }}</button>
        </div>
        <div class="border-b border-gray-200 mb-8"></div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardLeft.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardLeft.subtitle }}</div>
            </div>
          </div>
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardRight.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardRight.subtitle }}</div>
            </div>
          </div>
        </div>
        <p class="text-gray-800 mb-4">{{ currentTech.intro }}</p>
        <ul class="space-y-6 mb-8">
          <li v-for="(adv, idx) in currentTech.advantages" :key="idx" class="flex items-start">
            <span class="advantage-icon-box">
              <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#ef7c5b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle v-if="idx===0" cx="12" cy="12" r="3"/>
                <path v-if="idx===0" d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009.4 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 01-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9.4a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                <path v-if="idx===1" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <template v-if="idx===2">
                  <rect x="3" y="3" width="18" height="14" rx="2" ry="2"/>
                  <path d="M7 19h10M9 7l2 2 4-4"/>
                </template>
              </svg>
            </span>
            <span class="text-gray-800">{{ adv }}</span>
          </li>
        </ul>
        <div class="text-center">
          <a :href="resolveLink(externalLinks.techLearnMore)" target="_blank" rel="noopener noreferrer" class="learn-more-btn inline-block">了解更多</a>
        </div>
        <div class="mt-8 text-center text-gray-500">值得信赖的证券经纪服务商</div>
      </div>
    </section>

    <section class="trading-capabilities py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">专业保险经纪服务</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb1.png" class="w-13 h-13" alt="全终端覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">全渠道服务覆盖</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 线上线下全周期保险服务</li>
                  <li>• 保单查询、投保申请、理赔提交随时随地办理</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb2.png" class="w-13 h-13" alt="多市场覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">多产品方案矩阵</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 涵盖寿险、健康险、年金、家财险等主流产品</li>
                  <li>• 支持保险+信托、保险+医疗等复合型方案定制</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb3.png" class="w-13 h-13" alt="实时监控">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">专属顾问服务</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 人工跟进续期、保障检视与额度调整提醒</li>
                  <li>• 由顾问为您同步行业政策变动与产品更新动态</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb4.png" class="w-13 h-13" alt="专业研究支持">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">专家顾问团队</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 持证人、精算师、理赔专家组成的顾问网络</li>
                  <li>• 家庭风险诊断与个性化方案设计</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb5.png" class="w-13 h-13" alt="风控保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">专业风险顾问</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 提供保障缺口分析与风险预警建议</li>
                  <li>• 理赔进度跟进与争议协商专业支持</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg白色 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb6.png" class="w-13 h-13" alt="合规保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">合规服务保障</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 规范的线下见证、合同面签与档案合规管理</li>
                  <li>• 客户信息保密与隐私安全管理制度</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="account-types py-16 bg白色">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">支持账户类型</h2>
        <p class="text-base text-gray-800 mb-8">个人与机构均可开立股票账户</p>
        <div class="flex items-center justify-center gap-12 mb-6">
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="个人账户">
            <div class="text-gray-900">个人账户</div>
          </div>
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="机构账户">
            <div class="text-gray-900">机构账户</div>
          </div>
        </div>
        <div class="max-w-3xl mx-auto border border-gray-200 rounded-lg p-6 bg-white text-left">
          <h4 class="font-semibold text-gray-900 mb-2">开立机构账户</h4>
          <p class="text-gray-700 text-sm leading-relaxed">机构账户提供更丰富的交易工具与更灵活的服务。如需开立机构账户，请联系客户经理。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InsuranceCustomers',
  metaInfo: {
    title: '保险客户 - 红土证券'
  },
  data() {
    return {
      defaultTradingUrl: 'https://redland.trade.wbrks.com/Webtrading',
      externalLinks: {
        privilegeLearnMore: '',
        investorTools: '',
        techLearnMore: ''
      },
      currentTechTab: 'cloud',
      techTabs: [
        { key: 'cloud', label: '产品动态配置' },
        { key: 'order', label: '保费与赔付管理' },
        { key: 'market', label: '风控与合规审计' },
        { key: 'funds', label: '业务一致性保障' }
      ],
      techContent: {
        cloud: {
          cardLeft: { title: '保险风控', subtitle: '购力计算' },
          cardRight: { title: '资产可视', subtitle: '风险先知' },
          intro: '支持个性化产品组合与动态定价策略，提升方案配置效率与市场响应能力',
          advantages: [
            '专业团队支持根据客户专业定制、风险偏好、财务状况进行产品推荐',
            '保费测算与风险定价模型，基于市场动态核保规则生成报价',
            '多维度风险校验与合规筛查，确保方案符合监管与机构承保要求'
          ]
        },
        order: {
          cardLeft: { title: '动态核保', subtitle: '精准赔付' },
          cardRight: { title: '保费精算', subtitle: '风控闭环' },
          intro: '精算模型优化赔付方案，同步提升风险控制精度与理赔服务效率',
          advantages: [
            '支持批量报价、阶梯费率、续保优惠等复杂计费方案定制',
            '提供线下风险评估、理赔争议协商与财务对账服务',
            '执行人工资金清分、单证核对与机构间账务稽核'
          ]
        },
        market: {
          cardLeft: { title: '全链审计', subtitle: '风控随行' },
          cardRight: { title: '合规同步', subtitle: '风险洞见' },
          intro: '数据一致性、监管合规化、多源风控与智能审计机制结合，构建全面业务风险防线',
          advantages: [
            '执行人工尽职调查、背景核实与可疑交易线下审查',
            '支持黑名单筛查、反洗钱监测、客户适当性管理，确保全流程业务合规',
            '支持多维度审计查询、异常操作告警与自动化合规证据收集'
          ]
        },
        funds: {
          cardLeft: { title: '业务同源', subtitle: '风控一体' },
          cardRight: { title: '跨链一致', subtitle: '流程互通' },
          intro: '建立全周期业务连续流程，在关键节点执行人工交叉验证，保障信息一致性。',
          advantages: [
            '使用统一的线下流程引擎，确保投保单、核保、批改和理赔各环节状态同步更新。',
            '设立关键操作线下复核与审批环节，确保步骤合规且流程衔接顺畅。',
            '执行保费与赔款的线下台账核对，确保每笔资金入账清晰、支付可追溯。'
          ]
        }
      }
    }
  },
  methods: {
    resolveLink(url) {
      if (typeof url === 'string' && url.trim()) {
        return url.trim();
      }
      return this.defaultTradingUrl;
    }
  },
  computed: {
    currentTech() {
      return this.techContent[this.currentTechTab] || this.techContent.cloud
    }
  }
}
</script>

<style scoped>
.hero-banner { position: relative; height: 40vh; min-height: 600px; overflow: hidden; background:url("@/assets/487585e4e8bd59c74850991ff73e9fe8.jpg"); background-size: cover; background-position: center; background-repeat: no-repeat; }
.banner-content { position: absolute; top: 50%; left: 15%; transform: translateY(-50%); z-index: 10; }
.text-content { text-align: left; }
.brand-name { font-size: 1.5rem; font-weight: 300; color: white; margin-bottom: 0.5rem; letter-spacing: 0.1em; }
.main-title { font-size: 3.5rem; font-weight: 700; color: white; margin-bottom: 0.5rem; letter-spacing: 0.05em; line-height: 1.1; }
.subtitle { font-size: 1.2rem; font-weight: 300; color: white; margin-bottom: 2rem; letter-spacing: 0.05em; opacity: 0.9; }
.cta-button { background: transparent; color: white; border: 2px solid white; padding: 0.75rem 2rem; font-size: 1rem; font-weight: 500; border-radius: 4px; cursor: pointer; transition: all 0.3s ease; letter-spacing: 0.05em; }
.cta-button:hover { background: white; color: #1e3a8a; transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2); }
@media (max-width: 1024px) { .hero-banner { height: 80vh; min-height: 500px; } .main-title { font-size: 2.5rem; } .banner-content { left: 10%; } }
@media (max-width: 768px) { .hero-banner { height: 70vh; min-height: 400px; } .main-title { font-size: 2rem; } .brand-name { font-size: 1.2rem; } .banner-content { left: 8%; } .cta-button { padding: 0.6rem 1.5rem; font-size: 0.9rem; } }
@media (max-width: 640px) { .hero-banner { height: 60vh; min-height: 350px; } .main-title { font-size: 1.8rem; } .brand-name { font-size: 1rem; } .banner-content { left: 5%; } }
.nav-tab { padding: 0.75rem 1rem; font-weight: 500; color: #6b7280; border-bottom: 2px solid transparent; transition: all 0.2s; position: relative; cursor: pointer; background: none; border: none; }
.nav-tab.active { color: #1f2937; border-bottom-color: #1f2937; }
.nav-tab:hover { color: #374151; }
.tech-card { background: #ffffff; border: 1px solid #e5e7eb; border-radius: 0.75rem; }
.tech-card-body { padding: 1.5rem; text-align: center; }
.tech-title { font-size: 1.75rem; font-weight: 700; color: #ef7c5b; }
.tech-subtitle { margin-top: 0.25rem; color: #9ca3af; }
.advantage-icon-box { width: 48px; height: 48px; min-width: 48px; display: inline-flex; align-items: center; justify-content: center; border: 2px dashed #ef7c5b; border-radius: 12px; margin-right: 12px; background: #fff7f4; }
.learn-more-btn { background: #ef7c5b; color: #ffffff; padding: 0.6rem 1.5rem; border: none; border-radius: 1.5rem; font-weight: 600; }
</style>
